import { useCallback, useEffect, useState } from 'react';
import { IAmrFilterValues, IAzureFiltersSearchApi, ICtFilterValues } from '@vivli/features/search/infrastructure/interface';
import { Subscription } from 'rxjs';

export function useFacetsHook({ getCtFilterValues, getAmrFilterValues }: IAzureFiltersSearchApi, isAmr = false) {
    const [amrFilterValues, setAmrFilterValues] = useState<IAmrFilterValues>();
    const [ctFilterValues, setCtFilterValues] = useState<ICtFilterValues>();

    const setAndSortCTFilterValues = useCallback((filterValues: ICtFilterValues) => {
        //sort funders and contributors
        filterValues?.funder?.sort((a, b) => a.value.localeCompare(b.value));
        filterValues?.orgName?.sort((a, b) => a.value.localeCompare(b.value));
        setCtFilterValues(filterValues);
    }, []);

    const handleFilterValues = useCallback((): Subscription => {
        if (isAmr) {
            return getAmrFilterValues().subscribe(setAmrFilterValues);
        } else {
            return getCtFilterValues().subscribe(setAndSortCTFilterValues);
        }
    }, [isAmr, setAndSortCTFilterValues]);

    const updateCtFilterValues = useCallback((updatedCtFilterValues: ICtFilterValues, ignoreSampleSize = false) => {
        if (ignoreSampleSize) {
            setCtFilterValues((prev) => ({ ...updatedCtFilterValues, actualEnrollment: prev.actualEnrollment }));
        } else {
            setCtFilterValues({ ...updatedCtFilterValues });
        }
    }, []);

    useEffect(() => {
        const filterSub = handleFilterValues();
        return () => {
            filterSub.unsubscribe();
        };
    }, [handleFilterValues]);

    return {
        ctFilterValues,
        amrFilterValues,
        updateCtFilterValues,
        setAmrFilterValues,
    };
}
